import React from "react"
import styled from "styled-components"
import { fonts } from "../../utils/fonts"
import { LayoutWrapper } from "../LayoutWrapper/LayoutWrapper"
import { color } from "../../utils/colors"
import FormattedArticle from "../../components/FormattedArticle/FormattedArticle"

const StyledWrapper = styled(LayoutWrapper)``

const StyledHeading = styled.h2`
  ${fonts.headingLarge};
  margin-bottom: 20px;
`
const StyledTitleLarge = styled.div`
  width: 50%;
  flex-shrink: 0;
  padding-right: 40px;
  border-right: solid 1px ${color.separatorGrey};
  color: ${({ color }) => color};
  padding-bottom: 150px;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 1100px) {
    padding-bottom: 80px;
  }
  @media screen and (max-width: 1000px) {
    border-right: none;
    padding-bottom: 20px;
    width: 100%;
  }
  @media screen and (max-width: 767px) {
    padding-right: 0;
  }
`

const StyledOption = styled.article`
  &:not(:last-child) {
    padding-bottom: 30px;
    margin-bottom: 50px;
    border-bottom: solid 1px ${color.separatorGrey};
  }
`

const StyledColumnWrapper = styled.div`
  padding-left: 40px;
  display: flex;
  flex-direction: column;
  padding-bottom: 150px;
  @media screen and (max-width: 1100px) {
    padding-bottom: 80px;
  }
  @media screen and (max-width: 1000px) {
    padding-left: 0;
    padding-bottom: 0;
  }
`

const StyledRowWrapper = styled.div`
  display: flex;
  border-bottom: solid 1px
    ${({ noBorder }) => (noBorder ? "transparent" : color.separatorGrey)};

  padding-top: 100px;
  padding-bottom: 80px;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    padding-top: 50px;
    padding-bottom: 40px;
  }
`

const StyledOptionHeading = styled.h3`
  ${fonts.headingMedium};
  margin-bottom: 30px;
  text-transform: uppercase;
`

const SupportOptions = ({
  id,
  heading,
  intro,
  options,
  equalSections,
  noBorder,
  headingColor,
}) => {
  return (
    <StyledWrapper id={id}>
      <StyledRowWrapper noBorder={noBorder}>
        <StyledTitleLarge equalSections={equalSections} color={headingColor}>
          <StyledHeading>{heading}</StyledHeading>
          <FormattedArticle article={intro} />
        </StyledTitleLarge>

        <StyledColumnWrapper>
          {options.map(({ heading, text }, index) => {
            return (
              <StyledOption>
                <StyledOptionHeading>
                  {" "}
                  {index + 1}.&nbsp;{heading}
                </StyledOptionHeading>
                <FormattedArticle article={text} />
              </StyledOption>
            )
          })}
        </StyledColumnWrapper>
      </StyledRowWrapper>
    </StyledWrapper>
  )
}

export default SupportOptions
